import { RankingStrategyTypes } from '../types';

export const mockRankingWeight: RankingStrategyTypes.RankingStrategyWeight = {
  weight: 20,
  name: 'Price',
  field: 'price',
  enabled: false,
  order: RankingStrategyTypes.RankingOrder.Asc,
};
